import { useTranslation } from 'react-i18next'
import React from 'react'

import { CloneFormHandler, useCloneForm } from './_form/CloneServiceOrderForm'
import { useCloneServiceOrder } from './_requests/cloneServiceOrder'
import AssignContent from './assign/AssignContent'
import AssignTypePicker from './assign/AssignTypePicker'
import Button from '../../../components/actions/Button'
import Separator from '../../../components/helpers/Separator'
import { useNavigationWithModalCloser } from '../../../utils/contexts/NavigationContext'
import { useLoggedUser } from '@btime/react-session'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'

const ModalFooter = ({ ...props }) => {
  const { t } = useTranslation()

  const [save, { loading }] = useCloneServiceOrder()
  const navigate = useNavigationWithModalCloser()
  const form = useCloneForm()
  const loggedUser = useLoggedUser()

  const isForSelf = loggedUser.id === form.user?.id && !props.loading
  const onSuccess = record => navigate(`/service-orders/${record?.id}/execution`)

  return (
    <SubmitBar label={t('clone')} loading={loading} onClick={save} {...props}>
      {isForSelf && (
        <Button disabled={loading} transparent color="dark3" onClick={() => save({ onSuccess })}>
          {'Clonar e executar'}
        </Button>
      )}
    </SubmitBar>
  )
}

const CloneForm = () => {
  return (
    <CloneFormHandler>
      <AssignTypePicker />
      <Separator weight={4} />
      <AssignContent />
      <Separator weight={6} />
      <ModalFooter />
    </CloneFormHandler>
  )
}

export default CloneForm
